import { isNull } from "lodash";
import { IAction, reducer } from "store";
import { DataRoomsAction } from "store/actions";
import {
  Connection,
  ConnectionPreview,
  DataRooms,
  GetConnectionRes,
  Platform,
  SupplierData,
  UpdateRelation
} from "store/types";

reducer.createHandler(
  DataRoomsAction.GetConnectionsSucccess,
  (state, { payload }: IAction<ConnectionPreview<string>[]>) => ({
    ...state,
    dataRooms: {
      ...state.dataRooms,
      connections: payload.map((item) => ({
        ...item,
        updated_at: item.updated_at ? new Date(item.updated_at) : null // ISO string to Date js
      }))
    }
  })
);

reducer.createHandler(
  DataRoomsAction.GetConnectionSuccess,
  (
    state,
    {
      payload
    }: IAction<{
      getConnectionRes: GetConnectionRes;
      suppliers: SupplierData[];
    }>
  ) => {
    if (!payload) {
      return { ...state, dataRooms: { ...state.dataRooms, connection: null } };
    }
    const { getConnectionRes, suppliers } = payload;
    const connection: Connection = {
      ...getConnectionRes,
      updated_at: getConnectionRes.updated_at ? new Date(getConnectionRes.updated_at) : null,
      relations:
        Array.isArray(getConnectionRes.funds) && getConnectionRes.funds.length
          ? getConnectionRes.funds.map((fund) => {
              const supplier = suppliers.find((s) => s.dataroom_fund == fund.id); // keep it ==
              return {
                consumer: supplier?.fund
                  ? {
                      id: supplier.id,
                      dealId: supplier.fund
                    }
                  : null,
                supplier: fund,
                ...(supplier?.files && { files: supplier.files }),
                ...(supplier?.processes &&
                  supplier.processes.length && {
                    processes: supplier.processes
                  }),
                ...(supplier?.last_sync_timestamp && {
                  last_sync: supplier.last_sync_timestamp
                }),
                ...(supplier?.last_index && {
                  last_index: supplier.last_index
                })
              };
            })
          : []
    };

    return {
      ...state,
      dataRooms: {
        ...state.dataRooms,
        connection
      }
    };
  }
);

reducer.createHandler(DataRoomsAction.UpdateRelationSuccess, (state, { payload }: IAction<UpdateRelation>) => {
  return {
    ...state,
    dataRooms: {
      ...state.dataRooms,
      connection: state.dataRooms.connection
        ? {
            ...state.dataRooms.connection,
            relations: state.dataRooms.connection?.relations.map((item) => {
              if (item.supplier.id === payload.supplierId) {
                return {
                  supplier: item.supplier,
                  consumer: payload.consumer
                };
              }
              return item;
            })
          }
        : null
    }
  };
});

reducer.createHandler(DataRoomsAction.DeleteConnectionSuccess, (state, { payload }: IAction<number>) => ({
  ...state,
  dataRooms: {
    ...state.dataRooms,
    connections: state.dataRooms.connections.filter((item) => item.id !== payload),
    connection: state.dataRooms.connection?.id === payload ? null : state.dataRooms.connection
  }
}));

reducer.createHandler(DataRoomsAction.SaveConnectionPreview, (state, { payload }: IAction<ConnectionPreview>) => ({
  ...state,
  dataRooms: {
    ...state.dataRooms,
    connections: state.dataRooms.connections.some((item) => item.id === payload.id) // Check is connection inside
      ? state.dataRooms.connections.map((item) => (item.id === payload.id ? payload : item)) // If inside update it
      : [...state.dataRooms.connections, payload] // If no such connection add it
  }
}));

reducer.createHandler(
  DataRoomsAction.SetConnectMessage,
  (state, { payload }: IAction<DataRooms["connectMessage"]>) => ({
    ...state,
    dataRooms: {
      ...state.dataRooms,
      connectMessage: payload
    }
  })
);

reducer.createHandler(DataRoomsAction.SetConnectMessageTimeout, (state, { payload }: IAction<string | null>) => {
  if (!state.dataRooms.connectMessage) return state;
  return {
    ...state,
    dataRooms: {
      ...state.dataRooms,
      connectMessage: isNull(payload)
        ? null
        : {
            ...state.dataRooms.connectMessage,
            countdown: payload
          }
    }
  };
});

reducer.createHandler(DataRoomsAction.SetPlatforms, (state, { payload }: IAction<Platform[]>) => ({
  ...state,
  dataRooms: {
    ...state.dataRooms,
    platforms: payload
  }
}));
